// extracted by mini-css-extract-plugin
export default {"quote":"Quote-module--quote--98ccf","citation":"Quote-module--citation--2846e","regular":"Quote-module--regular--546ad","bold":"Quote-module--bold--d5cb1"};